import  loadSurvey  from "../utils/SurveyLoader";

const state = {
  survey: null,
  // survey: loadSurvey(),
  showAppHeader: false,
  showAppFooter: false,
  noClientPage: false,
  dejaReponduPage: false,
  surveyWithClientCode: false,
  isSurveyCompleted: false,
  toogleNavbar: false
};

export default state;
